export default {
  baseMaplayers: {
    label: 'Base Layers',
    icon: 'assets/icons/dashboard/layers.svg',
    layers: [
      {
        label: 'Konnecta GeoServer',
        description:
          'Konnecta nautical chart with base map and world ports',
        img: 'assets/icons/dashboard/map-options/world-1.svg',
        layerGroup: [
          {
            hide: false,
            layer: 'nauti:naviqore_v2_map',
            style: 'nauti:naviqore_v2_map_light',
            styleDark: 'nauti:naviqore_v2_map_dark',
            bgColor: '0xDDEBEE',
            bgColorDark: '0x262626',
            startZoom: 0,
            endZoom: 19,
          },
          {
            hide: false,
            layer: 'nauti:unlocode_ports',
            style: 'nauti:naviqore_v2_worldports_light',
            styleDark: 'nauti:naviqore_v2_worldports_dark',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
      {
        label: 'Leaflet OpenStreetMap',
        description:
          'OpenStreetMap tiles rendered through Leaflet for a standard geographic view',
        img: 'assets/icons/dashboard/map-options/world-2.svg',
        layerGroup: [
          {
            hide: false,
            layer: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
      {
        label: 'Carto Voyager',
        description:
          'Carto Voyager basemap with a matching dark style for theme switching',
        img: 'assets/icons/dashboard/map-options/world-1.svg',
        layerGroup: [
          {
            hide: false,
            layer:
              'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png',
            layerDark:
              'https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}.png',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
    ],
  },
  overlayLayers: {
    label: 'Overlayers',
    icon: 'assets/icons/dashboard/map-options/Information.svg',
    layers: [
      {
        label: 'Piracy Event Occurancies',
        description: 'High Risk Areas',
        img: 'assets/icons/dashboard/map-options/Piracy%20Events.svg',
        layerGroup: [
          {
            layer: 'asam_events_heatmap',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
      {
        label: 'ECAs',
        description: 'IMO Emission Control Areas (SOx,NOx)',
        img: 'assets/icons/dashboard/map-options/Emission%20Control%20Areas.svg',
        layerGroup: [
          {
            layer: 'eca_reg14',
            startZoom: 0,
            endZoom: 8,
          },
        ],
      },
      {
        label: 'Time Zones',
        description: 'Time Zones',
        img: 'assets/icons/dashboard/map-options/Timezones.svg',
        layerGroup: [
          {
            layer: 'ne_10m_time_zones',
            style: 'nauti:naviqore_v2_timezones_light',
            styleDark: 'nauti:naviqore_v2_timezones_dark',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
      {
        label: 'Graticules 20m',
        description: 'Graticules 20°',
        img: '',
        layerGroup: [
          {
            layer: 'ne_10m_graticules_20',
            startZoom: 0,
            endZoom: 5,
            tooltip: 'Graticules with 20°',
            text: '20°',
          },
          {
            layer: 'ne_10m_graticules_15',
            startZoom: 5,
            endZoom: 6,
            tooltip: 'Graticules with 15°',
            text: '15°',
          },
          {
            layer: 'ne_10m_graticules_10',
            startZoom: 6,
            endZoom: 7,
            tooltip: 'Graticules with 10°',
            text: '10°',
          },
          {
            layer: 'ne_10m_graticules_5',
            startZoom: 7,
            endZoom: 10,
            tooltip: 'Graticules with 5°',
            text: '5°',
          },
        ],
      },
      {
        label: 'Bathymetry',
        description: 'Depth contours and seabed shading',
        img: 'assets/icons/dashboard/map-options/Information.svg',
        layerGroup: [
          {
            layer: 'nauti:ne_10m_bathymetry_all',
            style: 'nauti:naviqore_v2_bathymetry_light',
            styleDark: 'nauti:naviqore_v2_bathymetry_dark',
            bgColor: '0xDDEBEE',
            bgColorDark: '0x262626',
            renderBelowBase: true,
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
    ],
  },
};
